export default "__VITE_ASSET__lV9q2RHG__"